// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"1c919467","548":"50fe950a","569":"70178352","632":"b3f20026","873":"2b4210b8"}[chunkId] + ".chunk.js";
};